import JSEncrypt from "jsencrypt";

/** RSA-encrypt a password. JSEncrypt returns false when the payload is too large. */
export function encryptWithPublicKey(publicKey: string, plaintext: string): string {
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(publicKey);
  const encrypted = encrypt.encrypt(plaintext);
  if (!encrypted) {
    throw new Error(
      "Unable to encrypt this password. Try a shorter password or refresh the page and try again.",
    );
  }
  return encrypted;
}
